import { createActionGroup, props, emptyProps } from '@ngrx/store';
import { ErrorModel } from '@era/app';
import { ManagementTokens } from './management.state';

// ============================================================================
// VPP TOKEN RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ManagementTokensVppResolverActions = createActionGroup({
  source: 'Management tokens vpp resolver',
  events: {
    Requested: emptyProps(),
  },
});

// ============================================================================
// VPP TOKEN UI ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ManagementVppUiActions = createActionGroup({
  source: 'Management VPP UI',
  events: {
    'Token uploaded': props<{ token: ArrayBuffer }>(),
  },
});

// ============================================================================
// VPP TOKEN API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ManagementTokensVppApiActions = createActionGroup({
  source: 'Mdm API',
  events: {
    'Management vpp token loaded': props<{ payload: ManagementTokens['vpp'] }>(),
    'Management vpp token updated': props<{ payload: ManagementTokens['vpp'] }>(),
    'Management vpp token updated error': props<{ error: ErrorModel }>(),
    'Management vpp token loaded error': props<{ error: ErrorModel }>(),
  },
});

// ============================================================================
// DEP TOKEN RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ManagementTokensDepResolverActions = createActionGroup({
  source: 'Management tokens dep resolver',
  events: {
    Requested: emptyProps(),
  },
});

// ============================================================================
// DEP TOKEN UI ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ManagementDepUiActions = createActionGroup({
  source: 'Management DEP UI',
  events: {
    'Token uploaded': props<{ token: ArrayBuffer }>(),
  },
});

// ============================================================================
// DEP TOKEN API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ManagementTokensDepApiActions = createActionGroup({
  source: 'Mdm API',
  events: {
    'Management dep token loaded': props<{ payload: ManagementTokens['dep'] }>(),
    'Management dep token loaded error': props<{ error: ErrorModel }>(),
  },
});

export const DepApiActions = createActionGroup({
  source: 'Dep API',
  events: {
    'Management dep token updated': props<{ payload: ManagementTokens['dep'] }>(),
    'Management dep token updated error': props<{ error: ErrorModel }>(),
  },
});

// ============================================================================
// PUSH CERTIFICATE RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ManagementTokensPushResolverActions = createActionGroup({
  source: 'Management tokens push resolver',
  events: {
    Requested: emptyProps(),
  },
});

// ============================================================================
// PUSH CERTIFICATE CSR ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ManagementTokensPushCsrActions = createActionGroup({
  source: 'Management tokens push CSR',
  events: {
    'Download requested': emptyProps(),
  },
});

// ============================================================================
// PUSH CERTIFICATE UI ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ManagementPushUiActions = createActionGroup({
  source: 'Management PUSH UI',
  events: {
    'Token uploaded': props<{ token: ArrayBuffer }>(),
  },
});

// ============================================================================
// PUSH CERTIFICATE API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ManagementTokensPushApiActions = createActionGroup({
  source: 'Mdm API',
  events: {
    'Management push token loaded': props<{ payload: ManagementTokens['push'] }>(),
    'Management push CSR downloaded': emptyProps(),
    'Management push token loaded error': props<{ error: ErrorModel }>(),
    'Management push CSR downloaded error': props<{ error: ErrorModel }>(),
  },
});

export const PushApiActions = createActionGroup({
  source: 'Push API',
  events: {
    'Management push token updated': props<{ payload: ManagementTokens['push'] }>(),
    'Management push token updated error': props<{ error: ErrorModel }>(),
  },
});

// ============================================================================
// DEP CERTIFICATE ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ManagementTokensDepCertificateActions = createActionGroup({
  source: 'Management tokens dep certificate',
  events: {
    'Download requested': emptyProps(),
  },
});

export const DepCertificateApiActions = createActionGroup({
  source: 'Dep API',
  events: {
    'Management dep certificate downloaded': emptyProps(),
    'Management dep certificate downloaded error': props<{ error: ErrorModel }>(),
  },
});

// ============================================================================
// VENDOR CERTIFICATE RESOLVER ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ManagementTokensVendorResolverActions = createActionGroup({
  source: 'Management tokens vendor resolver',
  events: {
    Requested: emptyProps(),
  },
});

// ============================================================================
// VENDOR CERTIFICATE TOKEN ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ManagementTokensVendorTokenActions = createActionGroup({
  source: 'Management tokens vendor token',
  events: {
    'Download requested': emptyProps(),
  },
});

// ============================================================================
// VENDOR CERTIFICATE CSR ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ManagementTokensVendorCsrActions = createActionGroup({
  source: 'Management tokens vendor CSR',
  events: {
    'Download requested': emptyProps(),
  },
});

// ============================================================================
// VENDOR CERTIFICATE UI ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ManagementVendorUiActions = createActionGroup({
  source: 'Management vendor UI',
  events: {
    'Token uploaded': props<{ token: ArrayBuffer }>(),
  },
});

// ============================================================================
// VENDOR CERTIFICATE API ACTIONS (Group - using createActionGroup)
// ============================================================================

export const ManagementTokensVendorApiActions = createActionGroup({
  source: 'Mdm API',
  events: {
    'Management vendor token loaded': props<{ payload: ManagementTokens['vendor'] }>(),
    'Management vendor token downloaded': emptyProps(),
    'Management vendor CSR downloaded': emptyProps(),
    'Management vendor token loaded error': props<{ error: ErrorModel }>(),
    'Management vendor token downloaded error': props<{ error: ErrorModel }>(),
    'Management vendor CSR downloaded error': props<{ error: ErrorModel }>(),
  },
});

export const VendorApiActions = createActionGroup({
  source: 'Vendor API',
  events: {
    'Management Vendor token updated': props<{ payload: ManagementTokens['vendor'] }>(),
    'Management vendor token updated error': props<{ error: ErrorModel }>(),
  },
});
